var map = {
	"./blue-right-arrow.svg": "./src/assets/img/home-index/blue-right-arrow.svg",
	"./bread-crumb-angle.svg": "./src/assets/img/home-index/bread-crumb-angle.svg",
	"./btn-quick-start.svg": "./src/assets/img/home-index/btn-quick-start.svg",
	"./btn-view-all-course.svg": "./src/assets/img/home-index/btn-view-all-course.svg",
	"./claim.svg": "./src/assets/img/home-index/claim.svg",
	"./completed-chk.svg": "./src/assets/img/home-index/completed-chk.svg",
	"./course_sections-icon-1.svg": "./src/assets/img/home-index/course_sections-icon-1.svg",
	"./course_sections-icon-2.svg": "./src/assets/img/home-index/course_sections-icon-2.svg",
	"./ddl-arrow.svg": "./src/assets/img/home-index/ddl-arrow.svg",
	"./digital-maturity.gif": "./src/assets/img/home-index/digital-maturity.gif",
	"./digital-maturity.png": "./src/assets/img/home-index/digital-maturity.png",
	"./factory_future_icon.svg": "./src/assets/img/home-index/factory_future_icon.svg",
	"./green-right-arrow.svg": "./src/assets/img/home-index/green-right-arrow.svg",
	"./grid_icon.svg": "./src/assets/img/home-index/grid_icon.svg",
	"./header-onboarding-1.gif": "./src/assets/img/home-index/header-onboarding-1.gif",
	"./header-onboarding-1.svg": "./src/assets/img/home-index/header-onboarding-1.svg",
	"./header-onboarding-2.gif": "./src/assets/img/home-index/header-onboarding-2.gif",
	"./header-onboarding-2.svg": "./src/assets/img/home-index/header-onboarding-2.svg",
	"./header-onboarding-3.gif": "./src/assets/img/home-index/header-onboarding-3.gif",
	"./header-onboarding-3.svg": "./src/assets/img/home-index/header-onboarding-3.svg",
	"./header-onboarding-4.gif": "./src/assets/img/home-index/header-onboarding-4.gif",
	"./header-onboarding-4.svg": "./src/assets/img/home-index/header-onboarding-4.svg",
	"./home-slider1.svg": "./src/assets/img/home-index/home-slider1.svg",
	"./home-slider2.svg": "./src/assets/img/home-index/home-slider2.svg",
	"./home-slider3.svg": "./src/assets/img/home-index/home-slider3.svg",
	"./home-slider4.svg": "./src/assets/img/home-index/home-slider4.svg",
	"./inv-claim.svg": "./src/assets/img/home-index/inv-claim.svg",
	"./list_icon.svg": "./src/assets/img/home-index/list_icon.svg",
	"./my-assessment-icon.svg": "./src/assets/img/home-index/my-assessment-icon.svg",
	"./my-training-icon.svg": "./src/assets/img/home-index/my-training-icon.svg",
	"./opex_icon.svg": "./src/assets/img/home-index/opex_icon.svg",
	"./porduct-tour-card.svg": "./src/assets/img/home-index/porduct-tour-card.svg",
	"./quickstart2-1.svg": "./src/assets/img/home-index/quickstart2-1.svg",
	"./quickstart2-2.svg": "./src/assets/img/home-index/quickstart2-2.svg",
	"./quickstart2-3.svg": "./src/assets/img/home-index/quickstart2-3.svg",
	"./quikstart-1.svg": "./src/assets/img/home-index/quikstart-1.svg",
	"./quikstart-2.svg": "./src/assets/img/home-index/quikstart-2.svg",
	"./quikstart-3.svg": "./src/assets/img/home-index/quikstart-3.svg",
	"./quikstart-4.svg": "./src/assets/img/home-index/quikstart-4.svg",
	"./quikstart-5.svg": "./src/assets/img/home-index/quikstart-5.svg",
	"./share_assessment.svg": "./src/assets/img/home-index/share_assessment.svg",
	"./step1-assessment-results-26.gif": "./src/assets/img/home-index/step1-assessment-results-26.gif",
	"./step1-assessment-results.gif": "./src/assets/img/home-index/step1-assessment-results.gif",
	"./step2-assessment-results.gif": "./src/assets/img/home-index/step2-assessment-results.gif",
	"./step3-assessment-results.gif": "./src/assets/img/home-index/step3-assessment-results.gif",
	"./step4-assessment-results.gif": "./src/assets/img/home-index/step4-assessment-results.gif",
	"./uncompleted-chk.svg": "./src/assets/img/home-index/uncompleted-chk.svg",
	"./view-less-icon.svg": "./src/assets/img/home-index/view-less-icon.svg",
	"./vision_icon.svg": "./src/assets/img/home-index/vision_icon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/home-index sync recursive ^\\.\\/.*$";